import clsx from 'clsx'
import Link from 'next/link'
import { ReactNode } from 'react'

import { FullWidthContainer } from '@/shared/lib/components/full-width-container'
import { Heading } from '@/shared/ui/heading'

import cl from './SectionElements.module.scss'

interface ElementsSliderProps {
	className?: string
	title?: ReactNode
	children: ReactNode
	link?: {
		href: string
		text: ReactNode
	}
	action?: {
		text: ReactNode
		onClick: () => void
	}
	extra?: ReactNode
	variant?: 'section' | 'slider' | 'subsection'
}

export const SectionElements = (props: ElementsSliderProps) => {
	const { className, title, children, link, action, extra, variant = 'section' } = props
	const isSlider = variant === 'slider'
	const isSubsection = variant === 'subsection'

	return (
		<FullWidthContainer variant={variant}>
			<div className={clsx(cl.root, isSlider && cl.variant_slider, isSubsection && cl.variant_subsection, className)}>
				<div className={cl.root__content}>
					{extra && extra}

					<div className={cl.root__header}>
						{title && <Heading preset="h2">{title}</Heading>}
						{link && (
							<Link prefetch={false} href={link.href}>
								{link.text}
							</Link>
						)}
						{action && (
							<button className={cl.root__actionButton} type="button" onClick={action.onClick}>
								{action.text}
							</button>
						)}
					</div>
					<div className={cl.root__items}>{children}</div>
				</div>
			</div>
		</FullWidthContainer>
	)
}
